import { computed } from 'vue';
import { featureFlagService } from '@/models/feature-flag';
import { filtersToQueryParams } from '@/utils/filters/query';
function newInvoiceFilterEnabled() {
    return featureFlagService.can('new-invoice-filter-modal');
}
export function useNewInvoiceFilter() {
    return computed(newInvoiceFilterEnabled);
}
export function filteredQueryIndexLink(name, clauses, legacyQuery) {
    if (!newInvoiceFilterEnabled()) {
        return { name, query: legacyQuery };
    }
    return { name, query: filtersToQueryParams({ filters: clauses }) };
}
export function invoiceIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('invoice.index', clauses, legacyQuery);
}
export function clientIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('client.index', clauses, legacyQuery);
}
export function workActIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('work-act.index', clauses, legacyQuery);
}
export function commercialSuggestionIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('commercial-suggestion.index', clauses, legacyQuery);
}
export function sipStatementsIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('sip-statements.payments.index', clauses, legacyQuery);
}
export function expenseDocumentsIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('expense-documents.index', clauses, legacyQuery);
}
export function productIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('product.index', clauses, legacyQuery);
}
// Expenses exist as two modules with separate lists, so every link into "the expense list"
// has to resolve which one the company is on.
export function expenseIndexRouteName() {
    return featureFlagService.can('expense-new') ? 'expense-new.index' : 'expense.index';
}
export function useExpenseIndexRouteName() {
    return computed(expenseIndexRouteName);
}
// Only the new expense list has adopted the v2 surface — the legacy one filters from ?query
// alone and would drop a clause it doesn't read, so clauses travel only when it is the target.
export function expenseIndexLink(clauses, legacyQuery) {
    if (!featureFlagService.can('expense-new')) {
        return { name: 'expense.index', query: legacyQuery };
    }
    return filteredQueryIndexLink('expense-new.index', clauses, legacyQuery);
}
// reactive variant for a single static link (dashboard-style). for per-row / dynamic
//  links, call invoiceIndexLink() directly in the template instead.
export function useInvoiceIndexLink(clauses, legacyQuery) {
    return computed(() => invoiceIndexLink(clauses, legacyQuery));
}
